<div id="enrollment-agreement">
  <div class="page1">

    <h2 class="text-center fst-italic fw-bold mb-4">Modulo di Adesione al Corso di Ballo</h2>

    <p class="small">Il tesserato in forma individuale o accompagnata da un partner di ballo, si impegna con il seguente Modulo di Adesione a sottoscrivere, prendere nota e rispettare tutte le norme che regolano i prodotti e/o servizi che vengono descritti nel modulo di Adesione, e tutte le condizioni retro riportate.</p>

    <p class="small">La {{ this.studioInformationConfig?.field_studio_address?.[0]?.organization || this.studioInformationConfig?.field_studio_display_name?.[0]?.value }} con sede in
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.address_line1 }},
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.administrative_area }}
      {{ this.studioInformationConfig?.field_studio_address?.[0]?.postal_code }}<ng-container *ngIf="this.studioInformationConfig?.field_studio_vat_number?.[0]?.value">, P.IVA e C.F. {{ this.studioInformationConfig?.field_studio_vat_number?.[0]?.value }}</ng-container>,
      richiede con il presente, l'impegno dell'Aderente qui sotto descritto a sottoscrivere il seguente modulo e impegnandosi a prenderne visione e rispettare quanto messo in evidenza nelle tabelle sotto riportate.</p>

    <!-- Student Info + Payment/Services Side by Side -->
    <div class="row mb-3">
      <div class="col-6">
        <table class="table table-bordered small mb-0">
          <tr>
            <td class="fw-bold" style="width:35%">Nome Cognome</td>
            <td>{{ entityData?.['field_student']?.['title'] || '' }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Codice Fiscale</td>
            <td>{{ primaryContact?.field_fiscal_code || '' }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Indirizzo</td>
            <td>{{ primaryContact?.field_address?.address_line1 || '' }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Citt&agrave;</td>
            <td>
              {{ primaryContact?.field_address?.locality || '' }}
              <ng-container *ngIf="primaryContact?.field_address?.postal_code">
                {{ primaryContact?.field_address?.postal_code }}
              </ng-container>
            </td>
          </tr>
          <tr>
            <td class="fw-bold">Telefono</td>
            <td>{{ primaryContact?.field_cell_phone || '' }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Mail</td>
            <td>{{ primaryContact?.field_email || '' }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Data di nascita</td>
            <td>{{ primaryContact?.field_birthday | date }}</td>
          </tr>
        </table>

        <!-- Lesson Description Table -->
        <table class="table table-bordered small mb-0">
          <tr>
            <td class="fw-bold" style="width:40%">Descrizione</td>
            <td class="fw-bold" style="width:25%">Quantit&agrave;</td>
            <td class="fw-bold" style="width:35%">Costo Totale</td>
          </tr>
          <tr>
            <td>Lezioni Individuali</td>
            <td>{{ entityData?.['field_enrollment_lesson_count'] || '' }}</td>
            <td>&euro;{{ getOriginalPackageCost() | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td>Lezioni collettive</td>
            <td></td>
            <td></td>
          </tr>
          <tr><td>&nbsp;</td><td></td><td></td></tr>
          <tr><td>&nbsp;</td><td></td><td></td></tr>
          <tr>
            <td class="fw-bold">TOTALE</td>
            <td></td>
            <td class="fw-bold">&euro;{{ calculateTotalTuition() | number:'1.2-2' }}</td>
          </tr>
        </table>
      </div>

      <div class="col-6">
        <div class="small">
          <p class="fw-bold mb-1">B) MODALIT&Agrave; DI PAGAMENTO:</p>
          <p class="mb-1">La modalit&agrave; di <strong>pagamento anticipato</strong> dell'importo totale dei corsi o dei servizi sottoindicati,</p>
          <p class="mb-0">a)
            <ng-container *ngIf="sectionB?.line === 'a'; else blankLineA"><strong>{{ sectionB.amount | number:'1.2-2' }}</strong> &euro; ogni <strong>{{ sectionB.lessonsPerPayment || '_____' }}</strong> lezioni individuali a partire da <strong>{{ sectionB.startDate | date }}</strong></ng-container>
            <ng-template #blankLineA>_____ &euro; ogni _____ lezioni individuali a partire da _____</ng-template>
          </p>
          <p class="mb-0">b)
            <ng-container *ngIf="sectionB?.line === 'b'; else blankLineB"><strong>{{ sectionB.amount | number:'1.2-2' }}</strong> &euro; ogni <strong>{{ sectionB.every }}</strong> a partire da <strong>{{ sectionB.startDate | date }}</strong></ng-container>
            <ng-template #blankLineB>_____ &euro; ogni _____ giorni a partire da _____</ng-template>
          </p>
          <p class="mb-0">c) 1 RATA<ng-container *ngIf="sectionB?.line === 'c'"> <strong>&euro; {{ sectionB.installments[0].amount | number:'1.2-2' }} il {{ sectionB.installments[0].date | date }}</strong></ng-container></p>
          <p class="mb-0">&nbsp;&nbsp;&nbsp;&nbsp;2 RATA<ng-container *ngIf="sectionB?.line === 'c'"> <strong>&euro; {{ sectionB.installments[1].amount | number:'1.2-2' }} il {{ sectionB.installments[1].date | date }}</strong></ng-container></p>
          <p class="mb-0">d) saldo il <ng-container *ngIf="sectionB?.balanceDueDate; else blankLineD"><strong>{{ sectionB.balanceDueDate | date }}</strong></ng-container><ng-template #blankLineD>_____</ng-template></p>
          <p class="mb-2" [class.d-none]="!sectionB?.downPayment">Acconto: <strong>&euro; {{ sectionB?.downPayment?.amount | number:'1.2-2' }}</strong> il <strong>{{ sectionB?.downPayment?.date | date }}</strong></p>

          <p class="fw-bold mb-1">D) TEMPO DI FRUIZIONE DEI SERVIZI;</p>
          <p class="mb-1">Le lezioni e/o i servizi sopra descritti potranno essere usufruiti nel periodo compreso tra il
            <ng-container *ngIf="servicePeriodStart; else blankPeriodStart"><strong>{{ servicePeriodStart | date }}</strong></ng-container><ng-template #blankPeriodStart>_________</ng-template>
            e il
            <ng-container *ngIf="servicePeriodEnd; else blankPeriodEnd"><strong>{{ servicePeriodEnd | date }}</strong></ng-container><ng-template #blankPeriodEnd>_________</ng-template></p>
          <p class="mb-0">All'interno di questo periodo l'Aderente potr&agrave; partecipare a tutte le attivit&agrave; collettive predisposte e programmate per il proprio livello e concordare gli appuntamenti individuali. <strong>Le lezioni individuali devono eventualmente disdette almeno 24 ore prima, diversamente la lezione o il servizio saranno considerati come regolarmente usufruiti.</strong></p>
        </div>
      </div>
    </div>

    <!-- Health Declaration -->
    <div class="small mb-3">
      <p><strong>Dichiarazione sostitutiva di atto di notoriet&agrave;:</strong> l'Aderente, consapevole delle sanzioni penali richiamate dall'Art. 76 del D.p.r 28.12/2000 n. 445, in caso di caso di dichiarazioni mendaci e di formazione o uso di atti falsi <strong>DICHIARA,</strong> di aver consultato il proprio medico di fiducia e di essere perfettamente idoneo/a da un punto di vista sanitario alla pratica del ballo o comunque alla pratica sportiva non agonistica. L'Aderente si impegna inoltre a consegnare un Certificato Medico di Idoneit&agrave; Sportiva non agonistica prima dell'inizio dell'attivit&agrave; di ballo. Dichiaro pertanto di assumermi ogni responsabilit&agrave; sia civile che penale derivante dalla totale o parziale mendacit&agrave; della dichiarazione sopra citata e sollevo sia la Societ&agrave; che ogni singolo istruttore o dipendente che mi sar&agrave; assegnato da qualsiasi responsabilit&agrave; rinunciando espressamente ora per allora ad ogni azione risarcitoria/indennitaria o che comunque abbia lo scopo di ottenere il pagamento di una somma di denaro o equivalente che abbia la sua causa anche parziale e/o indiretta nella totale o parziale mendacit&agrave; della dichiarazione da me sopra rese.</p>
    </div>

    <!-- First Signature Block -->
    <div class="row mb-4">
      <div class="col-6">
        <p class="fw-bold mb-0">FIRMA DEL RESPONSABILE</p>
        <div class="border-bottom" style="height:40px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
               class="img-fluid" style="max-height:38px;"
               [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
        </div>
      </div>
      <div class="col-6">
        <p class="fw-bold mb-0">FIRMA DELL'ADERENTE</p>
        <div class="border-bottom" style="height:40px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:38px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
      </div>
    </div>

    <!-- Second Signature Declaration -->
    <div class="small mb-3">
      <p>Nel sottoscrivere l'adesione al modulo in questione dichiaro inoltre di aver attentamente letto le condizioni generali del servizio - riportate a tergo - che regolano il presente contratto e di approvare espressamente i punti sotto riportati, anche ai sensi e per gli effetti degli articoli 1341 e 1342 c.c.</p>
      <p class="mb-0">CONDIZIONI GENERALI DEL SERVIZIO: Certificato Medico; Responsabilit&agrave;; Modalit&agrave; del Servizio; Recesso e Rimborso; Propriet&agrave; Intellettuale; Patto di Non Concorrenza; Controversie.</p>
    </div>

    <!-- Second Signature Block -->
    <div class="row mb-3">
      <div class="col-6">
        <p class="fw-bold mb-0">FIRMA DEL RESPONSABILE</p>
        <div class="border-bottom" style="height:40px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url)"
               class="img-fluid" style="max-height:38px;"
               [src]="_enrollmentEntityData?.['field_representative_signature']?.[0]?.['url'] || entityData?.field_representative_signature?.url" />
        </div>
      </div>
      <div class="col-6">
        <p class="fw-bold mb-0">FIRMA DELL'ADERENTE</p>
        <div class="border-bottom" style="height:40px;">
          <img *ngIf="displaySignatures && (_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url)"
               class="img-fluid" style="max-height:38px;"
               [src]="_enrollmentEntityData?.['field_signature']?.[0]?.['url'] || entityData?.field_signature?.url" />
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <p class="fw-bold mb-0">LUOGO &amp; DATA &nbsp;&nbsp;&nbsp;
          {{ this.studioInformationConfig?.field_studio_address?.[0]?.locality || '' }},
          {{ this.entityData?.['field_sale_date'] | date }}
        </p>
      </div>
    </div>

  </div>

  <!-- The Condizioni Generali del Servizio back page is generated by
       getEnrollmentAgreementBackpageContent() (enrollment-agreement-backpage.content.ts)
       and rendered/printed after this agreement, same as the US Terms of Service. -->
</div>
